import type { To } from './index.h'

import * as model from './model'

export * as dom from './dom'
export * from './errors'
export * as hooks from './hooks'
export * from './index.h'
export * from './router'
export * as scroll from './scroll'
export * as bannerSlide from './banner-slide'
export * from './stage'
export { model }

/**
 * Helper for navigation
 */
export const navigate = (to: To): To => model.navigatePush(to)
navigate.push = model.navigatePush
navigate.replace = model.navigateReplace
navigate.go = model.navigateGo
navigate.back = model.navigateBack
navigate.backOrHome = model.navigateBackOrHome
navigate.forward = model.navigateForward

export const locationReplace = (to: string) => window.location.replace(to)
export const locationAssign = (to: string) => window.location.assign(to)

export const openWindow = (to: string, target: string, features?: string) =>
  window.open(to, target, features)
